export default "__VITE_ASSET__0G1SnmrC__"